// extracted by mini-css-extract-plugin
module.exports = {"launchbutton":"style__launchbutton__X6aR2","button":"style__button__MXhCA"};